/**
 * Returns a guaranteed-renderable image URL for a blog post.
 *
 * Old AI-generated blog posts in MongoDB were saved with an empty `image`
 * field, which causes broken-image icons in production. This helper picks a
 * category-appropriate stock fallback when no image is available.
 *
 * Mirror of the backend constants in blog_generator.py so both layers agree
 * on which placeholder to show.
 */
const CATEGORY_FALLBACK = {
  "TV Mounting": "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=1200&q=80",
  "Smart Home": "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1200&q=80",
  Networking: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=1200&q=80",
  Security: "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1200&q=80",
  "Home Theater": "https://images.unsplash.com/photo-1489599735734-79b4af4a4cda?auto=format&fit=crop&w=1200&q=80",
  Audio: "https://images.unsplash.com/photo-1493020258366-be3ead61c4d8?auto=format&fit=crop&w=1200&q=80",
  "Yacht & Marine": "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?auto=format&fit=crop&w=1200&q=80",
  "Business IT": "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80",
  "IT Support": "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80",
};

const DEFAULT_FALLBACK =
  "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80";

export function getBlogImage(post) {
  if (post?.image && typeof post.image === "string" && post.image.trim().length > 0) {
    return post.image;
  }
  return CATEGORY_FALLBACK[post?.category] || DEFAULT_FALLBACK;
}
